window.addEventListener('DOMContentLoaded', () => {
  const box = document.getElementById('box');
  const indicator = document.getElementById('indicator');
  const indicatorWrapper = document.querySelector('.indicator__wrapper');

  if (!box || !indicator || !indicatorWrapper) return;

  const mobileMedia = window.matchMedia('(max-width: 749px)');

  let scrollListenerAttached = false;
  let dragListenersAttached = false;
  let isDragging = false;
  let dragStartX = 0;
  let dragStartScrollLeft = 0;

  function maxScroll() {
    return Math.max(0, box.scrollWidth - box.clientWidth);
  }

  function thumbTravel() {
    return Math.max(0, indicatorWrapper.clientWidth - indicator.clientWidth);
  }

  function updateIndicator() {
    const ms = maxScroll();
    const tt = thumbTravel();
    if (ms <= 0 || tt <= 0) {
      indicator.style.transform = 'translateX(0)';
      return;
    }
    const scrollFraction = box.scrollLeft / ms;
    indicator.style.transform = `translateX(${scrollFraction * tt}px)`;
  }

  function syncIndicatorSize() {
    indicator.style.width = `${indicatorWrapper.clientWidth / 2}px`;
    updateIndicator();
  }

  function onIndicatorPointerDown(e) {
    if (!mobileMedia.matches || maxScroll() <= 0) return;
    if (e.pointerType === 'mouse' && e.button !== 0) return;

    isDragging = true;
    dragStartX = e.clientX;
    dragStartScrollLeft = box.scrollLeft;
    indicatorWrapper.classList.add('is-dragging');
    indicatorWrapper.setPointerCapture(e.pointerId);
  }

  function onIndicatorPointerMove(e) {
    if (!isDragging) return;
    const tt = thumbTravel();
    const ms = maxScroll();
    if (tt <= 0 || ms <= 0) return;

    const deltaX = e.clientX - dragStartX;
    const deltaScroll = (deltaX / tt) * ms;
    box.scrollLeft = Math.min(ms, Math.max(0, dragStartScrollLeft + deltaScroll));
  }

  function endIndicatorDrag(e) {
    if (!isDragging) return;
    isDragging = false;
    indicatorWrapper.classList.remove('is-dragging');
    try {
      indicatorWrapper.releasePointerCapture(e.pointerId);
    } catch (_) {
      /* capture may already be released */
    }
  }

  function onLostPointerCapture() {
    isDragging = false;
    indicatorWrapper.classList.remove('is-dragging');
  }

  function attachScrollSync() {
    if (!scrollListenerAttached) {
      box.addEventListener('scroll', updateIndicator, { passive: true });
      scrollListenerAttached = true;
    }
  }

  function detachScrollSync() {
    if (scrollListenerAttached) {
      box.removeEventListener('scroll', updateIndicator);
      scrollListenerAttached = false;
    }
  }

  function attachIndicatorDrag() {
    if (dragListenersAttached) return;
    indicatorWrapper.addEventListener('pointerdown', onIndicatorPointerDown);
    indicatorWrapper.addEventListener('pointermove', onIndicatorPointerMove);
    indicatorWrapper.addEventListener('pointerup', endIndicatorDrag);
    indicatorWrapper.addEventListener('pointercancel', endIndicatorDrag);
    indicatorWrapper.addEventListener('lostpointercapture', onLostPointerCapture);
    dragListenersAttached = true;
  }

  function detachIndicatorDrag() {
    if (!dragListenersAttached) return;
    indicatorWrapper.removeEventListener('pointerdown', onIndicatorPointerDown);
    indicatorWrapper.removeEventListener('pointermove', onIndicatorPointerMove);
    indicatorWrapper.removeEventListener('pointerup', endIndicatorDrag);
    indicatorWrapper.removeEventListener('pointercancel', endIndicatorDrag);
    indicatorWrapper.removeEventListener('lostpointercapture', onLostPointerCapture);
    dragListenersAttached = false;
    isDragging = false;
    indicatorWrapper.classList.remove('is-dragging');
  }

  function setupMobile() {
    attachScrollSync();
    attachIndicatorDrag();
    syncIndicatorSize();
  }

  function teardownMobile() {
    detachScrollSync();
    detachIndicatorDrag();
  }

  function applyLayout() {
    if (mobileMedia.matches) {
      setupMobile();
    } else {
      teardownMobile();
    }
  }

  applyLayout();
  mobileMedia.addEventListener('change', applyLayout);

  window.addEventListener('resize', () => {
    if (mobileMedia.matches) {
      syncIndicatorSize();
    }
  });
});
